/* @flow */
import * as React from "react";

import Header from "../UnitedHeader";

import { Container, ContainerInner, Top, Title } from "./shared-styles";

type Props = {
  title: React.Node,
  children: any
};

const HistoryPage = ({ title, children, type }: Props) => {
  const header = type === "widget" ? null : <Header />;
  return (
    <Container>
      {header}
      <ContainerInner>
        <Top>
          <Title>{title}</Title>
        </Top>
        {children}
      </ContainerInner>
    </Container>
  );
};

export default HistoryPage;



// WEBPACK FOOTER //
// ./src/components/HistoryPages/HistoryPage.js